



























import Vue from 'vue';
import VCCM from "vue-custom-context-menu";
import { Component, Prop } from "vue-property-decorator";
Vue.use(VCCM);

/*
    * Component's properties and events
*/
@Component({
    components: {
        VCCM
    }
})

export default class ExportContextComponent extends Vue {   
}
